import { Link } from '@framework-controls/core';
import React, { useMemo, useCallback } from 'react';
import moment from 'moment';
import css from './CalendarLinks.module.scss';

interface IProps {
    date: string;
    time: string;
    title: string;
    location: string;
    description: string;
    theme: string;
    linkEventHandler: (e: any, text: string) => void;
    addLogEntry: (action: string, screen: string, details: string) => void;
}

const CalendarLinks = (props: IProps) => {
    const { date, time, location, title, description } = props;
    const appointment = date !== undefined && time !== undefined ?
        date + ' ' + time.slice(0, 5) :
        '10/10/2020 08:30am';
    const apptDate = new Date(appointment);
    const startDate = moment.utc(apptDate).format('YYYYMMDDTHHmmssZ').replace('+00:00', 'Z');
    const msStartDate = moment.utc(apptDate).format('YYYYMMDDTHHmmss');
    const endTime = moment(apptDate).add(15, 'minutes');
    const endDate = moment.utc(endTime).format('YYYYMMDDTHHmmssZ').replace('+00:00', 'Z');
    const msEndDate = moment.utc(endTime).format('YYYYMMDDTHHmmss');

    let linkClassName = css.link;
    if (props.theme === 'colorSensitive') {
        linkClassName = css.linkADA;
    }


    const onClick = useCallback((link, id) => {
        window.open(link, '_blank', 'width=1000, height=600');
        props.addLogEntry('Add Appointment to Calendar', '', id);
    }, [props.addLogEntry]);

    const googleLink = useMemo(() => {
        let link = 'https://calendar.google.com/calendar/render';
        link += '?action=TEMPLATE';
        link += '&dates=' + startDate;
        link += '/' + endDate;
        link += '&location=' + encodeURIComponent(location);
        link += '&text=' + encodeURIComponent(title);
        link += '&details=' + encodeURIComponent(description);

        return (
            <Link className={linkClassName} id='google' onClick={() => onClick(link, 'GOOGLE')}>
                <div onClick={(e: any) => props.linkEventHandler(e, 'Google')}>
                    Google
                </div>
            </Link>
        );
    }, [startDate, endDate, location, title, description, onClick, linkClassName, props.linkEventHandler]);

    const yahooLink = useMemo(() => {
        let link = 'https://calendar.yahoo.com/?v=60&view=d&type=20';
        link += '&title=' + encodeURIComponent(title);
        link += '&st=' + startDate;
        link += '&dur=0015';
        link += '&desc=' + encodeURIComponent(description);
        link += '&in_loc=' + encodeURIComponent(location);

        return (
            <Link className={linkClassName} id='yahoo' onClick={() => onClick(link, 'YAHOO')}>
                <div onClick={(e: any) => props.linkEventHandler(e, 'Yahoo')}>
                    Yahoo
                </div>
            </Link>
        );
    }, [startDate, location, title, description, onClick, linkClassName, props.linkEventHandler]);

    const outlookLink = useMemo(() => {
        let link = 'https://outlook.live.com/owa/?rru=addevent';
        link += '&startdt=' + msStartDate;
        link += '&enddt=' + msEndDate;
        link += '&subject=' + encodeURIComponent(title);
        link += '&location=' + encodeURIComponent(location);
        link += '&body=' + encodeURIComponent(description);
        link += '&allday=false';
        link += '&uid=' + getRandomKey();
        link += '&path=/calendar/view/Month';

        return (
            <Link className={linkClassName} id='outlook' onClick={() => onClick(link, 'OUTLOOK')}>
                <div onClick={(e: any) => props.linkEventHandler(e, 'Outlook')}>
                    Outlook
                </div>
            </Link>
        );
    }, [msStartDate, msEndDate, location, title, description, onClick, linkClassName, props.linkEventHandler]);

    return (
        <div className={css.links}>
            {googleLink} | {yahooLink} | {outlookLink}
        </div>
    );
};

function getRandomKey() {
    const n = Math.floor(Math.random() * 999999999999).toString();

    return new Date().getTime().toString() + '_' + n;
}


export default CalendarLinks;